import { render } from "./AppBreadcrumb.vue?vue&type=template&id=25dc21d7"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__